module.exports = __webpack_public_path__ + "footer-logo.png?94a80e3a18d93f6bddc8a8b537bbacb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-logo.png
// module id = 152
// module chunks = 0